// extracted by mini-css-extract-plugin
module.exports = {"creditStepItem":"CreditSteps_creditStepItem__TYdNo","badge":"CreditSteps_badge__1w4vc","title":"CreditSteps_title__5PP3G"};